module.exports = __webpack_public_path__ + "img/bg-cursos-graduacao.63eb1e5e.png";